<template>
    <div>
        <NuxtLayout name="katalog">
            <template #leftPanel>
                <div ref="info">
                    <div class="page-title">Jevy ÚAP</div>
                    <p
                        class=""
                        v-html="
                            correctTypography(
                                'Přehled sledovaných jevů ÚAP zpřístupňuje obsah dokumentace územně analytických podkladů zvlášť pro obec a pro kraj ve struktuře přílohy č. 1 k vyhlášce č. 157/2024 Sb. V přehledu jsou uvedeny i kódy jevů platné do 1. 7. 2024.'
                            )
                        "
                    />
                    <div class="flex w-full items-center gap-4 py-4 2xl:py-6">
                        <button
                            class="grow border border-black-text p-2 hover:bg-black-text hover:text-white"
                            :class="{
                                'bg-black-text text-white': type === 'O',
                            }"
                            @click="type = 'O'"
                        >
                            ÚAP pro obec
                        </button>
                        <button
                            class="grow border border-black-text p-2 hover:bg-black-text hover:text-white"
                            :class="{
                                'bg-black-text text-white': type === 'K',
                            }"
                            @click="type = 'K'"
                        >
                            ÚAP pro kraj
                        </button>
                    </div>
                    <div class="">
                        <div class="relative flex w-full items-center gap-2">
                            <input
                                v-model="filters.title"
                                type="text"
                                placeholder="Hledat jev (kód nebo název)"
                                class="w-full rounded-none border-b border-black-text py-2 text-sm"
                                @keyup.enter="store.mobileLeftPanelOpen = false"
                                @keyup.escape="
                                    store.mobileLeftPanelOpen = false
                                "
                            />
                            <div
                                class="flex cursor-pointer"
                                @click="store.mobileLeftPanelOpen = false"
                            >
                                <Icon name="custom:search" />
                            </div>
                        </div>
                    </div>
                    <!-- <div class="border-b border-black-text px-2 py-4 2xl:py-6">
                        <div
                            class="flex cursor-pointer items-center gap-2"
                            @click="filters.type = 'O'"
                        >
                            <input
                                id="oType"
                                v-model="filters.type"
                                type="radio"
                                value="O"
                                class="radio"
                            />
                            <label
                                class="cursor-pointer"
                                for="oType"
                                >jevy pro obec</label
                            >
                        </div>
                        <div
                            class="flex cursor-pointer items-center gap-2"
                            @click="filters.type = 'K'"
                        >
                            <input
                                id="kType"
                                v-model="filters.type"
                                type="radio"
                                value="K"
                                class="radio"
                            />
                            <label
                                class="cursor-pointer"
                                for="kType"
                                >jevy pro kraj</label
                            >
                        </div>
                    </div> -->
                </div>
                <div
                    class="overflow-y-auto py-4 2xl:py-6"
                    :style="{
                        height:
                            'calc(100vh - ' +
                            (store.headerHeight + infoHeight) +
                            'px',
                    }"
                >
                    <div
                        v-for="oblast in OBLASTI"
                        :key="oblast.id"
                        class="flex cursor-pointer items-center gap-2"
                        @click="
                            handleOblastChange(oblast.id + ' ' + oblast.label)
                        "
                    >
                        <div
                            :id="'oblast' + oblast.id"
                            type="checkbox"
                            class="checkbox"
                            :class="{
                                'bg-black-text':
                                    filters.oblast ===
                                    `${oblast.id} ${oblast.label}`,
                            }"
                        />
                        <label
                            class="cursor-pointer"
                            :for="'oblast' + oblast.id"
                            >{{ oblast.id }} | {{ oblast.label }}</label
                        >
                    </div>
                </div>
            </template>
            <KjevJevAccordion
                v-for="(item, index) in filteredJevy"
                :key="index"
                :item
                :open="activeIndex === index"
                :type
            />
            <LoadingIndicator :active="isLoading" />
        </NuxtLayout>
    </div>
</template>

<script lang="ts" setup>
const { locale } = useI18n()
const localePath = useLocalePath()

watch(locale, async () => {
    if (locale.value === "en") {
        await navigateTo(localePath("/o-portalu"))
    }
})

const jevy = ref<JevItem[] | null>(null)
const isLoading = ref(false)

const store = useMainStore()
const route = useRoute()

const description = computed(() =>
    useLocaleValue(store.getPageInfo("jevy-uap"), "description")
)

useSeoMeta({
    title: "o-portalu-jevy-uap",
    description: () => description.value,
    ogTitle: () => `Jevy ÚAP | %siteName`,
})

const info = ref<HTMLElement | null>(null)
const { height: infoHeight } = useElementSize(info)

const activeIndex = ref<number | null>(0)

onMounted(async () => {
    isLoading.value = true
    jevy.value = await $fetch<JevItem[]>("seznamjevuview", {
        baseURL: import.meta.client ? store.apiBaseUrl : store.apiBaseUrlInt,
    })
    isLoading.value = false

    if (route.query.jev) {
        const idx = filteredJevy.value.findIndex(
            item => item.KOD === route.query.jev
        )
        if (idx > -1) {
            activeIndex.value = idx
            setTimeout(() => {
                const jevEl = document.getElementById("jevy-" + route.query.jev)
                if (jevEl) {
                    jevEl.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    })
                }
            }, 100)
        } else {
            activeIndex.value = null
        }
    } else {
        activeIndex.value = null
    }
})

const OBLASTI = [
    {
        id: "100",
        label: "Krajina",
    },
    {
        id: "200",
        label: "Město",
    },
    {
        id: "300",
        label: "Využití území",
    },
    {
        id: "400",
        label: "Ekonomika a potenciál",
    },
    {
        id: "500",
        label: "Zelená infrastruktura",
    },
    {
        id: "600",
        label: "Dopravní infrastruktura",
    },
    {
        id: "700",
        label: "Technická infrastruktura",
    },
    {
        id: "800",
        label: "Veřejná vybavenost",
    },
    {
        id: "900",
        label: "Hodnoty a limity",
    },
    {
        id: "1000",
        label: "Implementace",
    },
    {
        id: "1100",
        label: "Rozbor udržitelného rozvoje",
    },
]

const filters = reactive<{
    title: string
    //oblast: string[]
    oblast: string
}>({
    title: "",
    //oblast: [],
    oblast: "",
})

const type = ref<"O" | "K">("O")

function handleOblastChange(oblast: string) {
    if (filters.oblast === oblast) {
        filters.oblast = ""
    } else {
        filters.oblast = oblast
    }
}

const filteredJevy = computed(() => {
    if (!jevy.value) return []
    // clone original data
    //let filtered = JSON.parse(JSON.stringify(jevy.value)) as JevItem[]

    const formattedJevy = jevy.value.map(item => {
        const newItem = { ...item } as JevItemProcessed

        newItem.NEW_TEMATA = []
        const temata = item.TEMATA.split(";")
        temata.forEach((tema, idx) => {
            newItem.NEW_TEMATA.push({
                KODSNAZVEM: tema,
                RELEVANCE: item.RELEVANCE.split(";")[idx] as "O" | "K",
                OBLAST: item.OBLASTI.split(";")[idx] as string,
                TEMAINFO: item.TEMAINFO.split(";")[idx] as string,
                VAZBA: item.VAZBA.split(";")[idx] as string,
            })
        })
        newItem.NEW_VRSTVY = []
        const vrstvy = item.VRSTVY_ID.split(";")
        if (vrstvy[0] !== "–") {
            newItem.NEW_VRSTVY = vrstvy.map((vrstva, idx) => {
                return {
                    ID: vrstva,
                    NAZEV: item.VRSTVY.split(";")[idx] as string,
                    RELEVANCE: item.RELEVANCE_VRSTVY.split(";")[idx] as
                        | "O"
                        | "K",
                }
            })
        }
        return newItem
    })

    let filtered = formattedJevy.filter(item => {
        if (
            (item.KOD &&
                item.KOD.toLowerCase().includes(filters.title.toLowerCase())) ||
            (item.NAZEV &&
                item.NAZEV.toLowerCase().includes(filters.title.toLowerCase()))
        ) {
            return item
        }
        return null
    })
    // filter according to OBLAST
    // first check if OBLAST in JEV matches and then check relevancy to OBCE/KRAJE
    if (filters.oblast.length > 0) {
        filtered = filtered.filter(item => {
            return item.OBLASTI?.includes(filters.oblast)
            //return filters.oblast.some(oblast => item.OBLASTI?.includes(oblast))
        })
    }
    return filtered
})
</script>

<style></style>
